import React, { useEffect, useState } from 'react'
import { Col, Row, Image } from 'react-bootstrap'
import imgSKY from '../../../images/SKY.png'
import imgMettheir from '../../../images/MT.jpg'
import imgAstro from '../../../images/ASTRO.png'
import imgProInside from '../../../images/ProInside.png'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getContractDetailAPI } from '../../../services/contract'
import ContractFullTimeNav from './contract-nav-fulltime'
import moment from 'moment'
import { BsApp } from 'react-icons/bs'
import Error_500 from '../../error/error-500'

export default function FulltimePreview() {
  // const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const [data, setData] = useState([])
  const [signatureCEO, setSignatureCEO] = useState([])
  const [signatureTO, setSignatureTO] = useState([])
  const [signatureEMP, setSignatureEMP] = useState([])
  const [signatureVPPD, setSignatureVPPD] = useState([])
  const [signatureVP, setSignatureVP] = useState([])
  const [isConfirm2, setIsConfirm2] = useState()
  const [isConfirm3, setIsConfirm3] = useState()
  const [isConfirm4, setIsConfirm4] = useState()
  const [signaturePD, setSignaturePD] = useState([])
  const [isCheck3, setIsCheck3] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const idCard = searchParams.get('idCard')
  const phone = searchParams.get('phone')
  const orgId = searchParams.get('orgId')

  useEffect(() => {
    moment.locale('th')

    if (orgId) {
      getContractDetail()
    }
  }, [orgId, idCard, phone])

  const getContractDetail = async () => {
    try {
      setIsLoading(true)

      const param = { orgId, idCard, phone }
      const result = await getContractDetailAPI(param)
      setIsLoading(false)
      if (!result) return
      if (result.status) {
        setData(result.result)
        setSignatureCEO(result.result.signatures[0].ceo)
        setSignatureVP(result.result.signatures[2].vp)
        setSignatureVPPD(result.result.signatures[3].vp_pd)
        setSignatureTO(result.result.signatures[4].report_to)
        setSignatureEMP(result.result.signatures[5].employee)
        setSignaturePD(result.result.signatures_pd[2].pd3)
        setIsConfirm2(result.result.signatures_pd[1].pd2.is_confirm)
        setIsConfirm3(result.result.signatures_pd[2].pd3.is_confirm)
        setIsConfirm4(result.result.signatures_pd[3].pd4.is_confirm)

        setIsCheck3(result.result.signatures_pd[2].pd3.is_confirm)
        // }
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <>
      {isLoading && <div className="preloader"></div>}

      <ContractFullTimeNav
        data={data}
        isCheck3={isCheck3}
        signatureVP={signatureVP}
        signatureEMP={signatureEMP}
        signatureTO={signatureTO}
        signatureCEO={signatureCEO}
        signatureVPPD={signatureVPPD}
        getContractDetail={getContractDetail}
      />
      <Row>
        <Col xl={12}>
          <div
            className="p-3 fw-normal"
            style={{
              lineHeight: 2
            }}
          >
            <div
              className="d-flex justify-content-center"
              style={{
                height: 100
              }}
            >
              {data?.org_id === 1 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 115,
                    height: 60
                  }}
                  src={imgSKY}
                />
              ) : data?.org_id === 2 ? (
                <Image
                  className="mt-2"
                  style={{
                    width: 120,
                    height: 100
                  }}
                  src={imgMettheir}
                />
              ) : data?.org_id === 3 ? (
                <Image
                  className="mb-1"
                  style={{
                    width: 100,
                    height: 90
                  }}
                  src={imgAstro}
                />
              ) : data?.org_id === 5 ? (
                <Image
                  className="mt-3"
                  style={{
                    width: 140,
                    height: 70
                  }}
                  src={imgProInside}
                />
              ) : null}
            </div>
            <h5
              className="text-center mb-1"
              style={{
                fontSize: 20
              }}
            >
              {data?.org_th || '-'}
            </h5>
            <div className="text-center mb-3 fw-light">
              {data?.type_id === 1
                ? 'สัญญาจ้างงาน'
                : 'สัญญาจ้างงาน (แบบมีกำหนดระยะเวลา)'}
            </div>
            {/* edit-text-right */}

            <p className="fw-light small ">
              สัญญานี้ทำที่ {data?.org_th || '-'} เมื่อวันที่{' '}
              {data?.start_date
                ? moment(data?.start_date).add(543, 'year').format('DD/MM/YYYY')
                : '-'}{' '}
              <p>
                (ก) {signatureCEO?.title_th || '-'}
                {signatureCEO?.name_th || '-'} {signatureCEO?.surname_th || '-'}{' '}
                อายุ {signatureCEO?.age || '-'} ปี/โดยผู้มีอำนาจลงนามท้ายสัญญา/
                {data?.org_th || '-'} {data?.address1_th || '-'}{' '}
                {data?.address2_th || '-'} บัตรประจำตัวประชาชนเลขที่{' '}
                {signatureCEO?.id_card || '-'} ซึ่งต่อไปจะเรียกว่า “นายจ้าง”
                ฝ่ายหนึ่ง
              </p>{' '}
              <p>
                (ข) {data?.title_th || '-'}
                {data?.name_th || '-'} {data?.surname_th || '-'} อายุ{' '}
                {data?.age ? data.age : '-'} ปี อยู่บ้านเลขที่/สำนักงานเลขที่{' '}
                {data?.address_current ? data.address_current : '-'}{' '}
                {data?.sub_district_current || '-'} เขต/อำเภอ{' '}
                {data?.district_current || '-'} จังหวัด{' '}
                {data?.province_current || '-'} บัตรประจำตัวประชาชนเลขที่{' '}
                {data?.id_card || '-'} ซึ่งต่อไปจะเรียกว่า “ลูกจ้าง” ฝ่ายหนึ่ง
              </p>
            </p>

            {data?.type_id === 1 ? (
              <p className="fw-light small mt-0">
                &nbsp; &nbsp; &nbsp;
                &nbsp;โดยที่นายจ้างเป็นผู้ประกอบธุรกิจเกี่ยวกับ
                การให้บริการด้านเทคโนโลยีสารสนเทศครบวงจร
                มีความประสงค์จะว่าจ้างลูกจ้างเข้ามาทำงานในตำแหน่ง{' '}
                {data?.position_th || '-'}{' '}
                และโดยที่ลูกจ้างเป็นผู้มีความรู้ความเชี่ยวชาญ ในตำแหน่งดังกล่าว
                ประสงค์จะรับจ้างเป็นลูกจ้างให้กับนายจ้างดังนั้น
                ทั้งสองฝ่ายจึงตกลงทำสัญญากัน โดยมีข้อความดังต่อไปนี้
              </p>
            ) : (
              <p className="fw-light small mt-0">
                &nbsp; &nbsp; &nbsp;
                &nbsp;โดยที่นายจ้างเป็นผู้ประกอบธุรกิจเกี่ยวกับ
                การให้บริการด้านเทคโนโลยีสารสนเทศครบวงจร
                มีความประสงค์จะว่าจ้างลูกจ้างเข้ามาทำงานในตำแหน่ง{' '}
                {data?.position_th || '-'}{' '}
                และโดยที่ลูกจ้างเป็นผู้มีความรู้ความเชี่ยวชาญในตำแหน่งดังกล่าวประสงค์จะรับจ้างเป็นลูกจ้างให้กับนายจ้างดังนั้น
                ทั้งสองฝ่ายจึงตกลงทำสัญญากัน โดยมีข้อความดังต่อไปนี้
              </p>
            )}
            <h5
              className="fw-bold small mt-2 mb-3 text-center"
              style={{
                lineHeight: 2
              }}
            >
              ข้อ 1. วัตถุที่ประสงค์แห่งสัญญา
            </h5>

            <p
              className="fw-light small mt-0"
              style={{
                lineHeight: 2
              }}
            >
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp; นายจ้างตกลงรับลูกจ้างชื่อ{' '}
              {data?.title_th || '-'}
              {data?.name_th || '-'} {data?.surname_th || '-'} เป็นลูกจ้าง
              {data?.type_id === 1
                ? 'เป็นลูกจ้างประจำ และให้เริ่มทำงานตั้งแต่วันที่ '
                : 'ระยะเวลาทดลองงานตั้งแต่วันที่ '}{' '}
              {data?.type_id === 1
                ? data?.start_date
                  ? moment(data?.start_date)
                      .add(543, 'year')
                      .format('D MMMM YYYY')
                  : '-'
                : data?.start_date
                ? moment(data?.start_date)
                    .add(543, 'year')
                    .format('D MMMM YYYY')
                : '-' + ' ถึง ' + data?.contract_end
                ? moment(data?.contract_end)
                    .add(543, 'year')
                    .format('D MMMM YYYY')
                : '-'}{' '}
              ทำงานในตำแหน่ง {data?.position_th || '-'} ระดับ{' '}
              {data?.level_id || '-'} {data?.division_th || '-'}{' '}
              {data?.faction_th || '-'} {data?.department_th || '-'}{' '}
              ระยะเวลาทดลองงานตั้งแต่{' '}
              {data?.start_date
                ? moment(data?.start_date)
                    .add(543, 'year')
                    .format('D MMMM YYYY')
                : '-'}{' '}
              ถึง{' '}
              {data?.probation_date
                ? moment(data?.probation_date)
                    .add(543, 'year')
                    .format('D MMMM YYYY')
                : '-'}{' '}
              หากภายในกำหนดระยะเวลาทดลองการทำงาน “นายจ้าง”
              พิจารณาแล้วเห็นว่า”ลูกจ้าง”มีคุณสมบัติไม่เหมาะสม
              ไม่ว่าจะเป็นด้านพฤติกรรม ความรู้ความสามารถในการทำงาน
              หรือมีสถิติการมาทำงานสายหรือขาดงานบ่อยครั้งหรือเหตุอื่นใดอันเกี่ยวด้วยสภาพการทำงานตามที่ระบุไว้ในกฎระเบียบข้อบังคับเกี่ยวกับการทำงานของบริษัทแล้ว
              “นายจ้าง” อาจใช้สิทธิเลิกจ้าง
              โดยแจ้งล่วงหน้าตามกฎหมายก่อนครบกำหนดระยะเวลาทดลองงาน
              หรือจ่ายสินจ้างแทนการบอกกล่าวล่วงหน้าแทนก็ได้
            </p>

            <h5 className="fw-bold small mt-4 mb-4 text-center">
              ข้อ 2. ค่าจ้างและการชำระ
            </h5>
            <p className="fw-light small mt-0">
              ทั้งสองฝ่ายตกลงกำหนดค่าจ้างในอัตราค่าจ้างที่ระบุไว้ในใบแจ้งค่าตอบแทน
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp;
              เพื่อให้ขั้นตอนการจ่ายค่าจ้างให้แก่ลูกจ้างเป็นไปอย่างสอดคล้องในทางปฏิบัติงานของลูกจ้าง
              นายจ้างมีหลักเกณฑ์การตัดรอบเพื่อเก็บสถิติการทำงานและนำข้อมูลไปใช้คำนวณการจ่ายเงินเดือน
              โดยมีรายละเอียด ดังต่อไปนี้
            </p>

            <p className="fw-light small mt-0">
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp; (1)
              จ่ายเงินเดือนทุกวันสิ้นเดือนหากตรงกับวันหยุดเสาร์ และอาทิตย์
              บริษัทจะเลื่อนการจ่ายก่อนการหยุด
            </p>
            <p className="fw-light small mt-0 ">
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp; (2)
              ตัดรอบสรุปตารางการมาทำงานของพนักงาน ได้แก่ การลากิจ การขาดงาน
              และการมาสาย ระหว่างวันที่ 16 – 15 ของเดือน
              แล้วนำส่งส่วนงานเงินเดือนภายในวันที่ 24
              ของทุกเดือนเพื่อเป็นข้อมูลในการคำนวณการจ่ายเงินเดือน ยกตัวอย่าง
              สรุปการทำงานของพนักงานวันที่ 16 กรกฎาคม ถึงวันที่ 15 สิงหาคม
              เป็นการสรุปเพื่อใช้คำนวณการจ่ายเงินเดือนของเดือนสิงหาคม
            </p>
            <p className="fw-light small mt-0 mb-0">
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp; (3) ทั้งนี้ วิธีและขั้นตอนการปฏิบัติ
              ให้ทั้งสองฝ่ายยึดถือ และปฏิบัติตามข้อบังคับเกี่ยวกับการทำงาน
              (พนักงาน ประจำสำนักงาน) หมวดที่ 6 การบริหารค่าจ้าง/เงินเดือน
            </p>
            <p className="fw-light small mt-0">
              {' '}
              &nbsp; &nbsp; &nbsp; &nbsp; โดยนายจ้างจะจ่ายค่าจ้าง
              ให้แก่ลูกจ้างในวันสุดท้ายของทุกเดือน ณ ที่ทำการของนายจ้าง
              หรือจ่ายผ่านบัญชีเงินฝากธนาคารของลูกจ้าง
              หรือตามที่นายจ้างเห็นสมควร
            </p>

            <h5 className="fw-bold small mt-4 mb-4 text-center">
              ข้อ 3. ข้อสัญญาของลูกจ้าง
            </h5>
            <p className="fw-light small mt-0">ลูกจ้างสัญญาและทราบดีว่า</p>
            <p className="fw-light small mt-0">
              (3.1) จะปฏิบัติตามคำรับรองของลูกจ้าง
              คำรับรองที่ปรากฏอยู่ในใบสมัครงาน (ถ้ามี)
              ข้อบังคับเกี่ยวกับการทำงาน ระเบียบ ประกาศ
              และหรือคำสั่งของนายจ้างที่มีอยู่ในขณะทำสัญญา
              หรือที่จะมีขึ้นต่อไปในภายหน้า และตกลงให้ถือว่า คำรับรอง
              ข้อบังคับเกี่ยวกับการทำงาน ระเบียบ ประกาศ
              และหรือคำสั่งดังกล่าวเป็นส่วนหนึ่งของสัญญานี้ด้วย
            </p>
            <p className="fw-light small mt-0">
              &nbsp; &nbsp; &nbsp;
              ลูกจ้างสัญญาว่าหากลูกจ้างกระทำการหรืองดเว้นการกระทำการหรือยินยอมให้บุคคลอื่นใดกระทำการใด
              ๆ โดยเจตนาหรือกระทำการประมาทเลินเล่อ
              เป็นเหตุให้นายจ้างได้รับความเสียหายอย่างร้ายแรง
              ไม่ว่าโดยตรงหรือโดยโดยอ้อม
              ลูกจ้างตกลงยินยอมชดใช้ค่าเสียหายให้กับนายจ้างโดยครบถ้วนเต็มจำนวน{' '}
            </p>
            <p className="fw-light small mt-0">
              (3.2) นายจ้างมีสิทธิ ดังต่อไปนี้
            </p>
            <p className="fw-light small mt-0">
              (3.2.1) กำหนด แก้ไขเปลี่ยนแปลง ยกเลิก
              หรือเพิ่มเติมวันและเวลาทำงานปกติ วันหยุด วันลา
              เวลาพักและหรือสวัสดิการ
            </p>
            <p className="fw-light small mt-0">
              (3.2.2) กำหนด หรือแก้ไขเปลี่ยนแปลงข้อบังคับเกี่ยวกับการทำงาน
              สภาพการจ้าง รวมทั้งการโอนย้ายตำแหน่ง หรือหน้าที่การงานในบริษัท
              หรือบริษัทในเครือตามที่นายจ้างจะเห็นสมควร
              โดยลูกจ้างพร้อมที่จะปฏิบัติงานทั้งในเขตกรุงเทพมหานครและต่างจังหวัด
            </p>
            <p className="fw-light small mt-0">
              (3.3) การที่นายจ้างตกลงรับลูกจ้างเข้าทำงานกับบริษัทตามสัญญานี้
              เนื่องมาจากลูกจ้างได้แจ้ง แสดงหลักฐาน หรือให้คำรับรองต่อนายจ้างว่า
              เป็นผู้มีคุณสมบัติ ประวัติและความประพฤติ
              และมีความสามารถตามที่นายจ้างกำหนดไว้
              ซึ่งลูกจ้างได้ทราบรายละเอียดต่าง ๆ ดีแล้ว ทั้งนี้
              เอกสารประกอบการสมัครงานให้ถือเป็นส่วนหนึ่งของสัญญาจ้างงานฉบับนี้ด้วย
              ดังนั้น หากปรากฏในภายหลังไม่ว่ากรณีใด ๆ ว่า ลูกจ้างมีคุณสมบัติ
              หรือความสามารถไม่ตรง หรือ ไม่เหมาะสมกับที่ได้แจ้ง แสดงหลักฐาน
              หรือรับรองไว้ หรือแสดงหลักฐานอันเป็นเท็จ
              หรือปกปิดข้อความจริงซึ่งควรบอกให้แจ้งอันอาจทำให้นายจ้างไม่รับเข้าทำงานกับนายจ้าง
              ถือเป็นการผิดสัญญา และจงใจทำให้นายจ้างได้รับความเสียหาย
              ลูกจ้างยินยอมให้นายจ้างมีสิทธิเลิกจ้างลูกจ้างได้ทันทีโดยไม่ต้องจ่ายค่าชดเชยและค่าเสียหายใด
              ๆ ทั้งสิ้น
            </p>
            <p className="fw-light small mt-0">
              (3.4) หากเกิดความชำรุดเสียหาย
              สูญหายแก่ทรัพย์สินของนายจ้างซึ่งอยู่ภายในที่ทำการของนายจ้างที่ลูกจ้างทำงานอยู่
              และอยู่ในความดูแลรับผิดชอบของลูกจ้าง
              ไม่ว่าจะเกิดจากความผิดของลูกจ้างหรือไม่ก็ตาม
              ลูกจ้างตกลงเป็นผู้รับผิดชอบแก้ไข จัดหามาแทน
              หรือชดใช้ค่าเสียหายแก่นายจ้างแล้วแต่กรณีเองทั้งสิ้นทันทีที่นายจ้างแจ้งให้ลูกจ้างรับผิดชอบ
            </p>
            <p className="fw-light small mt-0">
              (3.5) จะไม่แสวงหา หรือรับเอาไม่ว่าในทางตรง
              หรือทางอ้อมเพื่อตนเองหรือเพื่อผู้อื่นซึ่งทรัพย์สินหรือประโยชน์ใด ๆ
              ในการที่ลูกจ้างกระทำ หรือละเว้นการกระทำตามตำแหน่งหน้าที่
              หรือกระทำการที่ได้รับมอบหมาย นอกจากนายจ้างจ่ายให้
              หรือพึงจ่ายให้ตามปกติตามระเบียบ
              หรือตามข้อบังคับเกี่ยวกับการทำงานของนายจ้าง
            </p>
            <p className="fw-light small mt-0">
              {' '}
              (3.6) จะไม่ประกอบธุรกิจ
              หรือทำงานให้กับบริษัทที่ประกอบธุรกิจประเภทเดียวกันกับนายจ้าง
              รวมทั้งจะไม่กระทำการใด ๆ อันเป็นการแข่งขันกับธุรกิจของนายจ้าง
              เฉพาะที่อาศัยข้อมูลการค้าอันเป็นความลับทางการค้าของนายจ้าง
              ไม่ว่าทางตรงหรือทางอ้อม ตลอดจนไม่กระทำหรือช่วยเหลือ
              หรือยินยอมให้บุคคลใดกระทำการดังกล่าว ตลอดระยะเวลาของสัญญานี้
              และภายในกำหนดระยะเวลา 6 เดือน นับแต่วันที่สัญญานี้สิ้นสุดลง
            </p>
            <p className="fw-light small mt-0">
              (3.7) ลูกจ้างจะไม่กระทำการใช้ เปิดเผย และหรือเอาไป
              ซึ่งข้อมูลการค้าอันเป็นความลับทางการค้าของนายจ้าง
              และหรืออนุญาตให้บุคคลอื่นกระทำการดังกล่าว
              โดยไม่ได้รับความยินยอมจากนายจ้างเป็นลายลักษณ์อักษร
              ไม่ว่าข้อมูลการค้านั้นจะอยู่ในรูปแบบใด
            </p>
            <p className="fw-light small mt-0">
              (3.8) ลูกจ้างตกลงให้บรรดาลิขสิทธิ์
              และหรือสิทธิบัตรและหรือทรัพย์สินทางปัญญาอื่นใดที่เกิดขึ้นในระหว่างที่เป็นลูกจ้างของนายจ้างเฉพาะที่เกี่ยวข้องกับงานในตำแหน่งหน้าที่
              ให้ตกเป็นของนายจ้างแต่เพียงผู้เดียว นับแต่เวลาที่ได้กระทำขึ้น และ
              จะไม่ทำซ้ำ ดัดแปลง หรือกระทำการใด ๆ อันเป็นการละเมิดต่อนายจ้าง
              ตลอดจนไม่ยินยอมให้บุคคลใดกระทำการดังกล่าว
              ไม่ว่าจะเกิดความเสียหายแก่นายจ้างหรือไม่ก็ตาม
              รวมทั้งจะไม่นำงานที่ละเมิดทรัพย์สินทางปัญญาของบุคคลอื่นเข้ามาทำงาน
              ตามสัญญานี้ด้วย
            </p>
            <p className="fw-light small mt-0">
              (3.9) ลูกจ้างต้องรักษาความลับ และหรือข้อมูลภายในของบริษัทฯ
              ไม่นำไปเปิดเผย หรือแสวงหาผลประโยชน์แก่ตนเอง
              หรือเพื่อผลประโยชน์แก่ผู้อื่น ไม่ว่าทางตรงหรือทางอ้อม
              รวมทั้งต้องไม่ทำการซื้อขาย โอนหรือรับโอนหลักทรัพย์ของบริษัทฯ
              โดยใช้ความลับ และหรือข้อมูลภายในของบริษัท
              และหรือเข้าทำนิติกรรมอันใด โดยใช้ความลับ และหรือข้อมูลภายใน
              ของบริษัท อันอาจก่อให้เกิดความเสียหายต่อบริษัท
              ไม่ว่าทางตรงหรือทางอ้อม
            </p>
            <p className="fw-light small mt-0">
              (3.10) ลูกจ้างในหน่วยงานที่ได้รับข้อมูลภายในบริษัท
              ต้องไม่ใช้ข้อมูลดังกล่าวก่อนเปิดเผยสู่สาธารณชน และต้องไม่ทำการ
              ซื้อขาย โอนหรือรับโอนหลักทรัพย์ของบริษัทฯ ในช่วงระยะเวลา 1 เดือน
              ก่อนที่งบการเงินรายไตรมาสและงบการเงินประจำปี จะเปิดเผยสู่สาธารณชน
              และหลังการเปิดเผยข้อมูลดังกล่าวอย่างน้อย 3 วัน
            </p>
            <p className="fw-light small mt-0">
              (3.11)
              หากลูกจ้างมีหนี้ที่เป็นไปเพื่อสวัสดิการที่เป็นประโยชน์แก่ลูกจ้างฝ่ายเดียว
              ลูกจ้างตกลงยินยอมให้นายจ้างมีสิทธิหักหนี้จำนวนดังกล่าวจากค่าจ้าง
              ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่าล่วงเวลาในวันหยุดได้
              ไม่ว่าทั้งหมดหรือบางส่วน ไม่ว่าสัญญานี้จะสิ้นสุดลงแล้วหรือไม่ก็ตาม
              จนกว่าหนี้ดังกล่าวจะระงับสิ้นไป
            </p>
            <p className="fw-light small mt-0">
              ลูกจ้างสัญญาว่าจะปฏิบัติตามกฎหมายว่าด้วยภาษีอากร แรงงาน
              และกฎหมายอื่น ๆ ที่เกี่ยวข้องโดยเคร่งครัดทั้งยินยอมให้นายจ้าง
              หักภาษีเงินได้ ณ ที่จ่าย หรือหักเงินสมทบเข้ากองทุนประกันสังคม
              เพื่อส่งให้แก่ทางราชการตามกฎหมาย
            </p>
            <p className="fw-light small mt-0 mb-0 ">
              (3.12)
              การลาออกจากการเป็นพนักงานของลูกจ้างต้องแจ้งให้นายจ้างอนุมัติรับทราบเป็นลายลักษณ์อักษรล่วงหน้าเป็นเวลาอย่างน้อย
            </p>
            <p className="fw-light small mt-1 text-center d-flex gap-5">
              <span>
                <BsApp /> 30 วัน{' '}
              </span>
              <span>
                <BsApp /> 60 วัน{' '}
              </span>
              <span>
                <BsApp /> 90 วัน{' '}
              </span>
              <span>
                <BsApp /> อื่น ๆ
              </span>
            </p>
            <p className="fw-light small mt-0">
              ซึ่งนายจ้างตกลงกับลูกจ้างเพื่อมิให้มีผลกระทบเกิดความเสียหายแก่นายจ้าง
              นับจากวันที่นายจ้างอนุมัติรับทราบเป็นลายลักษณ์อักษร
              จึงจะถือว่าการลาออกของลูกจ้างนั้นถูกต้องสมบูรณ์ตามสัญญาจ้างงานฉบับนี้{' '}
            </p>
            <p className="fw-light small mt-0">
              3.12 (ก) ก่อนสถานภาพการเป็นลูกจ้างสิ้นสุดลง
              ลูกจ้างต้องทำการส่งมอบงานซึ่งเป็นงานต่อเนื่อง หรืองานอยู่ระหว่างทำ
              ต่อให้ผู้รับทำหน้าที่ต่อจากลูกจ้าง หรือตัวแทน
              รับมอบงานเป็นลายลักษณ์อักษรจึงจะถือว่าการลาออกนั้นเสร็จสิ้นสมบูรณ์
            </p>
            <p className="fw-light small mt-0">
              3.12 (ข) หากลูกจ้างมิได้ปฏิบัติตามข้อ 3.12 (ก)
              ลูกจ้างตกลงยินยอมให้นายจ้างมีสิทธิชะลอการจ่ายค่าจ้าง ค่าล่วงเวลา
              ค่าทำงานในวันหยุด และค่าล่วงเวลาในวันหยุดได้
              ไม่ว่าทั้งหมดหรือบางส่วน
              ไม่ว่าสัญญานี้จะสิ้นสุดลงแล้วหรือไม่ก็ตามจนกว่าลูกจ้างจะทำการส่งมอบงานตามข้อ
              3.12 (ก) ให้เสร็จสิ้นเป็นที่เรียบร้อยแก่นายจ้าง
            </p>
            <p className="fw-light small mt-0">
              (3.13) ภายหลังจากที่ลูกจ้างได้ลาออก
              และพ้นสภาพจากการเป็นพนักงานแล้ว
              หากนายจ้างพบว่าเกิดความเสียหายอันเนื่องมาจากการปฏิบัติหน้าที่ของลูกจ้างในขณะที่ยังเป็นพนักงานอยู่
              ลูกจ้างรับว่าจะชดใช้ความเสียหายที่เกิดแก่นายจ้างตามความเสียหาย
              ที่เกิดขึ้นจริงทั้งจำนวนทันที
              ที่นายจ้างแจ้งให้รับทราบเป็นลายลักษณ์อักษรพร้อมหลักฐานซึ่งแสดงถึงที่มาของความเสียหาย
              ที่เกิดแก่นายจ้าง{' '}
            </p>
            <p className="fw-light small mt-0">
              (3.14) ลูกจ้างรับว่า จะไม่เรียกร้องค่าชดเชยกับนายจ้าง
              ซึ่งเลิกจ้างในกรณีหนึ่ง กรณีใด ดังต่อไปนี้
            </p>
            <p className="fw-light small mt-0">
              (ก) ทุจริตต่อหน้าที่หรือกระทำความผิดอาญาโดยเจตนาแก่นายจ้าง
            </p>
            <p className="fw-light small mt-0">
              (ข) จงใจให้นายจ้างได้รับความเสียหาย
            </p>
            <p className="fw-light small mt-0">
              (ค) ประมาทเลินเล่อเป็นเหตุให้นายจ้างได้รับความเสียหายอย่างร้ายแรง
            </p>
            <p className="fw-light small mt-0">
              (ง)
              ฝ่าฝืนข้อบังคับเกี่ยวกับการทำงานหรือระเบียบหรือคำสั่งของนายจ้างอันชอบด้วยกฎหมายและเป็นธรรม
              และนายจ้างได้ตักเตือนเป็นหนังสือแล้ว
              เว้นแต่กรณีที่ร้ายแรงนายจ้างไม่จำเป็นต้องตักเตือน หนังสือเตือน
              ให้มีผลบังคับได้ไม่เกินหนึ่งปีนับแต่วันที่ลูกจ้างได้กระทำผิด
            </p>
            <p className="fw-light small mt-0">
              (จ)
              ละทิ้งหน้าที่เป็นเวลาสามวันทำงานติดต่อกันไม่ว่าจะมีวันหยุดคั่นหรือไม่ก็ตามโดยไม่มีเหตุอันสมควร
            </p>
            <p className="fw-light small mt-0">
              (ฉ) ได้รับโทษจำคุกตามคำพิพากษาถึงที่สุดให้จำคุก
              เว้นแต่เป็นโทษสำหรับความผิดที่ได้กระทำโดยประมาท หรือความผิดลหุโทษ
            </p>
            <h5 className="fw-bold small mt-4 mb-4 text-center">
              ข้อ 4. หลักประกันการปฏิบัติตามสัญญา
            </h5>
            <p className="fw-light small mt-0 mb-0">
              เพื่อเป็นหลักประกันการปฏิบัติตามสัญญาตลอดจนความรับผิดและหนี้สินอื่นใดของลูกจ้าง
              ลูกจ้างตกลงว่า จะจัดให้ข้าราชการระดับ ซี 4 ขึ้นไป หรือบุคคล
              ซึ่งเป็นลูกจ้างเอกชนมีอัตราเงินเดือนเป็น 2 เท่าของลูกจ้าง
              เข้าค้ำประกันการปฏิบัติตามสัญญาของลูกจ้างให้กับนายจ้าง
              เป็นกรณีไปตามแต่ที่นายจ้างกำหนดในแต่ละตำแหน่งงานที่ต้องรับผิดชอบเกี่ยวกับการเงินหรือทรัพย์สินของนายจ้างซึ่งอาจก่อให้เกิดความเสียหายแก่นายจ้างได้หากสัญญานี้ยังไม่สิ้นสุดลง
              แต่ผู้ค้ำประกันหลุดพ้นความรับผิด จากสัญญานี้ ไปไม่ว่าด้วยเหตุใด
              ลูกจ้างจะต้องจัดหาผู้ค้ำประกันใหม่ ซึ่งมีคุณสมบัติตรงตามหลักเกณฑ์
              และเงื่อนไข ตามวรรคแรกให้กับนายจ้างก่อนการเริ่มงาน
              ตามที่ระบุไว้ในสัญญาจ้างงานฉบับนี้
            </p>
            <p className="fw-light small mt-1 d-flex gap-5">
              <span>
                <BsApp /> ต้องทำสัญญาค้ำประกัน{' '}
              </span>
              <span>
                <BsApp /> ไม่ต้องทำสัญญาค้ำประกัน{' '}
              </span>
              <span>
                <BsApp /> อื่น ๆ{' '}
              </span>
            </p>
            <h5 className="fw-bold small mt-4 mb-4 text-center">
              ข้อ 5. การผิดนัดผิดสัญญา
            </h5>
            <p className="fw-light small mt-0">
              หากลูกจ้างผิดนัดผิดสัญญานี้โดยจงใจหรือประมาทเลินเล่ออย่างร้ายแรง
              ทำให้นายจ้างได้รับความเสียหายลูกจ้างตกลงยินยอมให้นายจ้างมีสิทธิบอกเลิกสัญญา
              และหรือ มีสิทธิเรียกค่าเสียหายจากลูกจ้าง
              โดยให้นายจ้างมีสิทธินำค่าเสียหายมาหักออกจากค่าจ้าง ค่าล่วงเวลา
              ค่าทำงานในวันหยุด และหรือค่าล่วงเวลาในวันหยุดได้
              และหากยังไม่เพียงพอกับค่าเสียหายที่เกิดขึ้น
              นายจ้างมีสิทธิเรียกค่าเสียหายจากลูกจ้างได้อีก
            </p>

            <h5 className="fw-bold small mt-4 mb-4 text-center">
              ข้อ 6. ข้อตกลงอื่น ๆ
            </h5>
            <p className="fw-light small mt-0"></p>
            <p className="fw-light small mt-0">
              6.1 การผ่อนผัน ผ่อนเวลา หรือการละเว้นการใช้สิทธิใด ๆ
              ของคู่สัญญาฝ่าย หนึ่งที่มีอยู่ต่อคู่สัญญาอีกฝ่ายหนึ่งตามสัญญานี้
              ไม่ถือว่าคู่สัญญาฝ่ายนั้นได้สละสิทธิประโยชน์นั้นต่อคู่สัญญาอีกฝ่ายหนึ่งแต่อย่างใด
            </p>
            <p className="fw-light small mt-0">
              6.2 การบอกกล่าว ทวงถาม หรือส่งเอกสารใด ๆ อันพึงมีไปยังคู่สัญญาอีก
              ฝ่ายหนึ่งตามภูมิลำเนาตามสัญญาให้ถือว่าเป็นการส่งโดยชอบ
              และคู่สัญญาอีกฝ่ายได้รับทราบแล้ว นับแต่วันที่คำบอกกล่าว ทวงถาม
              หรือเอกสารนั้นพึงไปถึงตามปกติ
            </p>
            <p className="fw-light small mt-0">
              สัญญานี้ทำขึ้นเป็นสองฉบับ มีข้อความถูกต้องตรงกัน
              ทั้งสองฝ่ายได้ทราบ และเข้าใจ ข้อความในสัญญานี้โดยตลอดดีแล้ว
              เห็นว่าถูกต้องตรงตามเจตนาของตน จึงลงลายมือชื่อ และประทับตราบริษัท
              (ถ้ามี) ไว้เป็นสำคัญต่อหน้าพยาน และต่างยึดถือไว้ฝ่ายละฉบับ
            </p>

            {isConfirm2 === 1 && isConfirm3 === 1 && isConfirm4 === 1 ? (
              <div
                className="border-2 mt-5 p-5 card d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: '5px',
                  border: 'dotted',
                  maxHeight: '300px'
                }}
              >
                {signaturePD && (
                  <div className="col-6">
                    <p className="fw-light text-center small mt-4 ">
                      <span className="m-0 p-0 d-flex justify-content-center">
                        <Image
                          src={signaturePD?.url || null}
                          style={{
                            width: '150px',
                            marginBottom: -25
                          }}
                        ></Image>
                      </span>
                      ลงชื่อ........................................................................
                      ผู้ดำเนินการ
                    </p>
                    <p className="fw-light text-center small mt-0">
                      ( {signaturePD?.title_th || '-'}
                      {signaturePD?.name_th || '-'}{' '}
                      {signaturePD?.surname_th || '-'} )
                    </p>
                    <p className="fw-light text-center small mt-0 ">
                      {signaturePD?.position_th || '-'}
                    </p>
                    <p className="fw-light text-center small mt-0">
                      วันที่{' '}
                      {signaturePD?.confirm_date_pd
                        ? moment(signaturePD?.confirm_date_pd)
                            .add(543, 'year')
                            .format('D MMMM YYYY HH:mm')
                        : '-'}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={12} className="">
          <hr />
          <div className="p-3 ">
            <div className="fw-light " style={{ fontSize: 12 }}>
              {data?.org_th} {data?.address1_th} {data?.address2_th} โทรศัพท์:{' '}
              {data?.tel_no} โทรสาร: {data?.fax_no}
            </div>
            <div className=" fw-light " style={{ fontSize: 12 }}>
              {data?.org_en} {data?.address1_en} {data?.address2_en} Telephone:{' '}
              {data?.tel_no} Fax: {data?.fax_no}
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}
